import React from "react";
// Orange cut images
import Artboard2 from "../../assets/orangecut/1page.webp";
import Artboard3 from "../../assets/orangecut/2page.webp";
import Artboard4 from "../../assets/orangecut/3page.webp";
import Artboard5 from "../../assets/orangecut/4page.webp";
import Artboard6 from "../../assets/orangecut/5page.webp";
import Artboard7 from "../../assets/orangecut/6page.webp";
import Artboard8 from "../../assets/orangecut/7page.webp";
import Artboard9 from "../../assets/orangecut/8page.webp";
import Artboard10 from "../../assets/orangecut/9page.webp";
import Artboard11 from "../../assets/orangecut/10page.webp";
import Artboard12 from "../../assets/orangecut/11page.webp";
import Artboard13 from "../../assets/orangecut/12page.webp";
import Artboard14 from "../../assets/orangecut/13page.webp";
import Artboard15 from "../../assets/orangecut/14page.webp";
import Artboard16 from "../../assets/orangecut/15page.webp";
import Artboard17 from "../../assets/orangecut/16page.webp";

const videoPath = "/video/firstpageorange.mp4";

export default function Orangecut() {
  // Orange cut images and video array
  const orangeCutMedia = [
    videoPath,
    Artboard2,
    Artboard3,
    Artboard4,
    Artboard5,
    Artboard6,
    Artboard8,
    Artboard9,
    Artboard10,
    Artboard7,
    Artboard11,
    Artboard12,
    Artboard13,
    Artboard14,
    Artboard15,
    Artboard16,
    Artboard17,
  ];

  // Helper function to determine if media is video
  const isVideo = (src) => src.endsWith(".mp4");

  // Helper function to render media (image or video)
  const renderMedia = (src, index) => {
    if (isVideo(src)) {
      return (
        <video
          key={index}
          src={src}
          className="w-full h-full"
          autoPlay
          muted
          loop
          controls
          controlsList="nodownload"
          playsInline
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      );
    }
    return (
      <img
        key={index}
        src={src}
        alt={`Media ${index + 1}`}
        className="max-w-full h-auto"
      />
    );
  };

  return (
    <>
      {/* Orange Cut Media Section */}
      <div className="flex flex-col gap-0 pt-16 pb-16">
        {orangeCutMedia.map((media, index) => (
          <div key={`orange-${index}`} className="relative w-full min-h-screen flex items-center justify-center">
            {/* 🔹 Blurred Background */}
            <div
              className="absolute inset-0 bg-cover bg-center blur-2xl"
              style={{ backgroundImage: `url(${Artboard2})` }}
            ></div>
            {/* 🔹 Centered Sharp Container */}
            <div className="relative z-10 flex justify-center items-center w-full h-full px-4">
              {renderMedia(media, index)}
            </div>
          </div>
        ))}
      </div>

      {/* Logo Section */}
      <section
        style={{
          width: "100%",
          minHeight: "25svh",
          scrollSnapAlign: "start",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "40px",
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          style={{
            width: "80px",
            height: "auto",
            opacity: 0.9,
          }}
        />
      </section>
    </>
  );
}